import { ICreateGestaoRecebimentoEpiUseCase } from "../../../presentation/useCases/create/create_gestao_recebimento_epi_use_case";
import { IGestaoEpiRepository } from "../../repositories/gestao_epi_repository";

export class CreateGestaoRecebimentoEpiUseCase implements ICreateGestaoRecebimentoEpiUseCase {
  constructor(private readonly repository: IGestaoEpiRepository) { }

  async createGestaoRecebimentoEpi(
    idGestaoEpi: number,
    idFornecedor: number | null,
    ca: string | null,
    quantidade: number | null,
    dataRecebimento: Date | null,
    dataValidade: Date | null,
    idCentroCusto: number | null,
    marca: string | null,
    notaFiscal: string | null,
    arquivoNotaFiscal?: File | null,
    valorUnitario?: number | null,
    valorTotal?: number | null,
  ): Promise<number> {
    return await this.repository.createGestaoRecebimentoEpi(
      idGestaoEpi,
      idFornecedor,
      ca,
      quantidade,
      dataRecebimento,
      dataValidade,
      idCentroCusto,
      marca,
      notaFiscal,
      arquivoNotaFiscal,
      valorUnitario,
      valorTotal
    );
  }
}
